/**
 * Drag payload of a note (pragmatic-drag-and-drop). A note is dragged inside Mysliarium to
 * reorder the feed and dropped on a Kanban column to become a card: the board's canvas
 * recognises this payload without knowing anything about the drawer.
 */
type Data = Record<string | symbol, unknown>;

export const noteData = (noteId: string) => ({ type: 'note', noteId });

export function isNote(data: Data): data is Data & ReturnType<typeof noteData> {
  return data.type === 'note' && typeof data.noteId === 'string';
}

/** A note in the feed as a drop target for reordering (the drawer's own monitor handles it). */
export const noteSlotData = (noteId: string) => ({ type: 'note-slot', noteId });

export function isNoteSlot(data: Data): data is Data & ReturnType<typeof noteSlotData> {
  return data.type === 'note-slot' && typeof data.noteId === 'string';
}
